import { UserLogin } from "../../content/login";

export function LoginPage() {
  return <UserLogin />;
}
